export function titleCase(word: string) {
  return word[0].toUpperCase() + word.slice(1).toLowerCase();
}

export function stringIsNumber(value: string) {
  return isNaN(Number(value)) === false;
}
